import * as React from 'react'

import {IconProps} from '.'

function Info({color, size}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
      <rect x="11" y="10" width="2" height="7" fill={color} />
      <rect x="11" y="7" width="2" height="2" fill={color} />
    </svg>
  )
}

export default Info
